<template>
  <div class="u-checkbox">
    <label class="no-select text-body-1" :class="{'disabled': disabled}">
      <input class="form-check-input"
             ref="checkboxInput"
             type="checkbox"
             :disabled="disabled"
             @change="handleCheckboxChange"
             v-model="checkboxValue">
      <span v-if="label" class="u-checkbox-label">
        {{ label }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: "UCheckbox",
  model: {
    prop: 'checked',
    event: 'checked'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    setPageChange: {
      type: Boolean,
      default: () => { return false }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    changeValue: {
      get() {
        return this.checked
      },
      set (val) {
        if (this.setPageChange) {
          this.$store.dispatch('setPageChanges')
        }
        this.$emit('checked', val)
      }
    }
  },
  data () {
    return {
      checkboxValue: false
    }
  },
  created() {
    this.checkboxValue = this.checked
  },
  methods: {
    handleCheckboxChange () {
      if (!this.disabled) {
        this.$emit('checked', this.checkboxValue)
        /*this.$nextTick(() => {
          this.checkboxValue = this.checked
        })*/
      }
    }
  },
  watch: {
    checked: {
      handler (val) {
        this.checkboxValue = val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.u-checkbox {

  label {
    display: flex;
    align-items: center;

    &:not(.disabled) {
      cursor: pointer;
    }

    .form-check-input {
      width: 17px;
      height: 17px;
    }

    .u-checkbox-label {
      margin-left: 5px;
    }
  }
}
</style>
